"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const components_1 = require("components");
const hooks_1 = require("hooks");
const useApplicationEDS_1 = require("./_hooks/useApplicationEDS");
const eds_store_1 = require("./_store/eds.store");
const getSlugs_1 = require("./_utils/getSlugs");
const gotoURL_1 = require("./_utils/gotoURL");
const DisabledEDS_1 = __importDefault(require("./DisabledEDS"));
function ApplicationEDS() {
    // Store
    const { edsEnabled, edsApplicant, edsInfoForm } = (0, eds_store_1.useEDSStore)();
    // Has Credit Application
    const creditApplicationId = edsApplicant?.creditApplication?.applicationId;
    // Vertical Type
    const verticalCheck1 = edsApplicant?.location?.vertical === 'ophthalmology_optometry'
        ? true
        : false;
    const verticalCheck2 = edsInfoForm?.specialty === 'ophthalmology_optometry' ? true : false;
    // Placement ID
    const PLACEMENT_ID = verticalCheck1 || verticalCheck2
        ? 'iframe-overlay-alphaeon-vision'
        : 'iframe-overlay-alphaeon';
    // State
    const [hasInit, setHasInit] = (0, react_1.useState)(false);
    const [canWaterfall, setCanWaterfall] = (0, react_1.useState)(null);
    const [currentAppId, setCurrentAppId] = (0, react_1.useState)(undefined);
    // Hooks
    const query = (0, hooks_1.useQuery)();
    const history = (0, react_router_dom_1.useHistory)();
    // API
    const { lenderRequirements, postVerifyEDS, postEventsEDS } = (0, useApplicationEDS_1.useApplicationEDS)({
        applicationId: currentAppId,
    });
    // Query Params
    const locationType = query.get('locationType');
    const placementId = query.get('placementId');
    // Track Card Event
    const trackCardEvent = (0, react_1.useCallback)((eventName, cardResult) => {
        // Post Event API Call
        postEventsEDS({
            applicationId: creditApplicationId ?? '',
            body: {
                name: eventName,
                body: {
                    ...cardResult,
                },
            },
        });
        // Capture offer received event
        if (eventName === 'CARD:UNIFIED_OFFERS_RECEIVED') {
            handleOffersReceived({
                result: cardResult?.result,
                prequalId: cardResult?.prequalificationId,
                creditAppId: creditApplicationId,
            });
        }
        if (eventName === 'CARD:RECEIVE_ACCOUNT_EXISTS') {
            // If account exists, handle account exists logic
            handleAccountExists({
                creditAppId: creditApplicationId,
            });
        }
        // Push to additional info page
        if (eventName === 'CARD:APPLICATION_COMPLETED' && canWaterfall) {
            handleApplicationCompleted({
                creditAppId: creditApplicationId,
            });
        }
    }, [canWaterfall]);
    const handleOffersReceived = ({ result, prequalId, creditAppId, }) => {
        // Mark Can Waterfall
        if (result === 'NOT_QUALIFIED') {
            setCanWaterfall(true);
        }
        // Make Post Event API Call
        if (creditAppId &&
            (result === 'NOT_QUALIFIED' || result === 'PREQUALIFIED')) {
            const prequalStatus = result.toLocaleLowerCase();
            postVerifyEDS({
                applicationId: creditAppId,
                body: {
                    prequalificationId: prequalId,
                    applicationStatus: prequalStatus === 'pending_approval' ? 'pending' : prequalStatus,
                },
            });
        }
    };
    const handleApplicationCompleted = ({ creditAppId, }) => {
        // Check Lender Reqs
        if (creditAppId) {
            /**
             * Trigger Lender Requirements API call
             * check useEffect for lenderRequirements
             */
            setCurrentAppId(creditAppId);
        }
        else {
            (0, gotoURL_1.gotoDecline)(history);
        }
    };
    const handleAccountExists = ({ creditAppId, }) => {
        eds_store_1.useEDSStore.setState({
            edsResult: {
                isExists: true,
                creditAppId: creditAppId,
            },
        });
        (0, gotoURL_1.gotoResult)(history);
    };
    (0, react_1.useEffect)(() => {
        if (lenderRequirements &&
            lenderRequirements.hasOwnProperty('collectAdditionalInfoSubprime')) {
            const isSubprime = lenderRequirements.collectAdditionalInfoSubprime;
            if (isSubprime === 'true' || isSubprime === true) {
                (0, gotoURL_1.gotoAddInfo)(history);
            }
            if (isSubprime === 'false' || isSubprime === false) {
                (0, gotoURL_1.gotoDecline)(history);
            }
        }
    }, [lenderRequirements]);
    // Effects
    (0, react_1.useEffect)(() => {
        if (window.BreadPayments && creditApplicationId) {
            const productPlacement = {
                financingType: 'card',
                locationType: locationType ?? 'landing',
                placementId: placementId ?? PLACEMENT_ID,
                domID: 'bread-payments-landing-placement',
            };
            const setupConfig = {
                loyaltyID: '',
                storeNumber: 99996,
                existingCardHolder: false,
                env: 'STAGE',
            };
            if (hasInit === false) {
                // Setup and Register
                window.BreadPayments.setup(setupConfig);
                window.BreadPayments.openExperienceForPlacement(productPlacement);
                // Mark init
                setHasInit(true);
            }
            if (hasInit === true) {
                // Events
                window.BreadPayments.on('CARD:*', (cardResult) => {
                    const eventName = window.BreadPayments.publicEventEmitter.emitter.event;
                    trackCardEvent(eventName, cardResult);
                });
            }
        }
    }, [window.BreadPayments, canWaterfall, hasInit]);
    return ((0, jsx_runtime_1.jsxs)("div", { className: "container min-height-600", children: [edsEnabled && ((0, jsx_runtime_1.jsx)("div", { id: "bread-payments-landing-placement", className: "text-center" })), (edsEnabled === null || !creditApplicationId) && ((0, jsx_runtime_1.jsx)("div", { className: "max-width-600 mar-auto text-center", children: (0, jsx_runtime_1.jsxs)(components_1.P, { children: ["Please re-start the application", ' ', (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: (0, getSlugs_1.getIntroSlug)(), children: "here" }), "."] }) })), edsEnabled === false && (0, jsx_runtime_1.jsx)(DisabledEDS_1.default, {})] }));
}
exports.default = ApplicationEDS;
